import { render, staticRenderFns } from "./FollowUpTimeline.vue?vue&type=template&id=6ec982ca&scoped=true&"
import script from "./FollowUpTimeline.vue?vue&type=script&lang=js&"
export * from "./FollowUpTimeline.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpTimeline.vue?vue&type=style&index=0&id=6ec982ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec982ca",
  null
  
)

export default component.exports